module.exports = __webpack_public_path__ + "static/media/gregs.96e93cce.jpg";